import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';
import type { DayDepthChartWidgetEntity } from '../../well-day-depth-widget/DayDepthChartWidget.entity';

import { WellDayDepthWidgetWrapper } from '../../well-day-depth-widget/DayDepthChartWidget';

export function renderDayDepthChartWidget(
  widget: DayDepthChartWidgetEntity,
  options: TWidgetRendererOptions
): TRenderWidget {
  return () => <WellDayDepthWidgetWrapper entity={widget} options={options} />;
}
